import {useTranslation} from 'react-i18next';
import styles from './styles.module.css';

export default function ErrorMessage({onRetry, message}) {
  const {t} = useTranslation();

  return (
    <div className={styles.error}>
      <p className={styles.errorText}>
        {message || t('campaignChat.error.message')}
      </p>
      {onRetry && (
        <button type="button" className={styles.retryButton} onClick={onRetry}>
          {t('campaignChat.error.retry')}
        </button>
      )}
    </div>
  );
}
